import { i18n } from '@/plugins/i18n'
import { statusVariant, statusStr } from '@/constants/settlementStatus'
import { settlementType } from '@/constants/settlementType'
import {IvrShopType} from "@/constants/IvrShopType";

export default [
    {
        field: 'id',
        title: i18n.t('label.settlement_id'),
        sortable: true,
        width: 65,
        selector: false,
        textAlign: 'left', // in rtl version means right
    },
    {
        field: 'full_name',
        title: i18n.t('label.user_full_name'),
        textAlign: 'left',
        template: (row) => {
            return '<a href="/users/' + row.user_id + '/details">'+row.full_name+'</a>'
        },
        sortable: true,
    },
    {
        field: 'amount',
        title: i18n.t('label.amount') + " (" + i18n.t('currency.rial') + ")",
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'wage',
        title: i18n.t('label.wage'),
        width: 90,
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'psp',
        title: i18n.t('label.psp'),
        sortable: false,
        textAlign: 'center',
        template: (row) => {
            switch(row.psp) {
                case 'mellat':
                    return '<div><img src="/assets/media/psp/mellat.png" width="32" height="32"></div>';
                case 'parsian':
                    return '<div><img src="/assets/media/psp/parsian.svg" width="32" height="32"></div>';
                case 'pasargad':
                    return '<div><img src="/assets/media/psp/pasargad.svg" width="32" height="32"></div>';
                case 'saman':
                    return '<div><img src="/assets/media/psp/saman.svg" width="32" height="32"></div>';
                case 'novin':
                    return '<div><img src="/assets/media/psp/novin.svg" width="32" height="32"></div>';
                case 'sepehr':
                    return '<div><img src="/assets/media/psp/sepehr.png" width="32" height="32"></div>';
                case 'irankish':
                    return '<div><img src="/assets/media/psp/irankish.png" width="32" height="32"></div>';
                case 'asanpardakht':
                    return '<div><img src="/assets/media/psp/ap-logo.png" width="32" height="32"></div>';
            }

            return '<span>' + row.psp + '</span>';
        },
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        width: 80,
        textAlign: 'center',
        template: (row) => {
            let variant   = 'badge-'+statusVariant(row.status)
            let status = statusStr.get(row.status)

            return '<div class="badge '+variant+' text-white">'+ status +'</div>'
        },
        sortable: true,
    },

    {
        field: 'created_at',
        title: i18n.t('label.date_created'),
        sortable: true,
        textAlign: 'center',
    },
    /* {
        field: 'type',
        title: i18n.t('label.settlement_type'),
        sortable: true,
        width: 80,
        textAlign: 'center',
        template: (row) => {
            let variant = '', type = '';

            if (row.type == settlementType.PAYMENT_HELPER) {
                variant = 'badge-success';
                type    = i18n.t('transaction.types.api')
            } else if (row.type == settlementType.PAYMAN) {
                variant = 'badge-success';
                type    = i18n.t('transaction.types.payman')
            } else if (row.type == settlementType.IVR) {
                variant = 'badge-success';
                type = i18n.t('label.ivr')
            }  else if (row.type == settlementType.VIP) {
                variant = 'badge-success';
                type = i18n.t('label.vip')
            } else if (row.type == settlementType.ALLOTMENT) {
                variant = 'badge-success';
                type    = i18n.t('transaction.types.allotment')
            } else if (row.type == settlementType.COLLECTIVE_PAYMENT_HELPER) {
                variant = 'badge-success-grass';
                type    = i18n.t('transaction.types.collective_payment_helper')
            } else if (row.type == settlementType.COLLECTIVE_DEDICATED) {
                variant = 'badge-success-grass';
                type    = i18n.t('transaction.types.collective_dedicated')
            } else if (row.type == settlementType.IVR_TO_WALLET) {
                variant = 'badge-primary';
                type = i18n.t('transaction.types.ivr_to_wallet')
            }  else if (row.type == 7) {
                variant = 'badge-primary';
                type = i18n.t('transaction.types.marketing_profit')
            }

            return '<div class="badge '+variant+' text-white">'+ type +'</div>'
        },
    }, */
    {
        field: 'website_address',
        title: i18n.t('label.website_address'),
        width: 80,
        sortable: false,
        template: (row) => {
            return '<a href="/gateways/' + row.shop_id + '/details">'+row.website_address+'</a>'
        },
        textAlign: 'center',
    },

]